<template>
  <div class="modal__outer _py-sm-4">
    <div class="modal__overlay" @click="overlayClick"></div>
    <div class="modal _pa-8" :class="customClass">
      <div class="modal__close" v-if="!noClose" @click="$emit('close')">
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13 1L1 13M1 1L13 13"
            stroke="#54585A"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <slot name="modalBody"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    customClass: {
      type: String,
    },
    noClose: Boolean,
    disableOverlay: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    overlayClick() {
      if (!this.disableOverlay && !this.noClose) {
        this.$emit('close')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.modal {
  position: relative;
  z-index: 100001;
  margin: auto;
  background-color: #fff;
  border-radius: 10px;
  width: 90vw;
  max-width: 592px;
  height: auto;

  &__outer {
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    z-index: 99999999;
    display: flex;
    align-items: flex-start;
    overflow-y: auto;
  }

  &__overlay {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1000;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.45);
  }

  &__close {
    position: absolute;
    top: 22px;
    right: 22px;
    cursor: pointer;
  }
}
</style>
